import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import VerticalMediaCard from '../item/card/VerticalMediaCard';
// eslint-disable-next-line arrow-body-style
const CourseProgressCard = ({ item }) => {
    // console.log('item:', item);
    return (_jsx(VerticalMediaCard, { item: item, size: "large" }));
};
export default observer(CourseProgressCard);
//# sourceMappingURL=CourseProgressCard.js.map